
<template>
  <div  class="pc_aboutgoods">
    <ul v-if="tableData.list.length>0" class="ulList">
      <li class="" v-for="(item,index) in tableData.list" :key="index">
        <div class="left">
          <img :src="item.corplogo_cn" alt="" />
        </div>
        <div class="center">
          <div class="userInformation">
            <p class="h7" @click.stop="exhjump(item)">
              {{item.corpname_en?item.corpname_en:'Company information is not  available now'}}
            </p>
            <p>Exhibitor：{{item.exrange_en}}</p>
            <p>Hall/Booth Number：{{item.booth}}</p>
          </div>
          <div class="aboutContent">
            <div>
              <p class="title">
                <span>标题：</span>
                <!-- {{item.title}}   -->
              </p>
              <!-- <div class="hoverAccording">
                <span class="sanjiao"></span>
                {{item.title}} </div> -->
            </div>
            <p >
              <span>Meeting Time：</span>
              {{item.date}}</p>
            <div class="con">
              <p>
                <span>Content：</span>
                <el-tooltip :content="item.connet" placement="bottom" effect="light">
                  <span>{{item.connet}}</span>
                </el-tooltip>
              </p>
              <!-- <div class="hoverAccording">
                <span class="sanjiao"></span>
                 {{item.connet}}
              </div> -->
            </div>
          </div>
          <p class="time">{{item.ctime}}</p>
        </div>
        <div class="right">
          <el-button :class="item.status*1==0?'reception ':'reception btn'" disabled>{{item.status*1==0?"undetermined":"Confirmed"}}</el-button>
          <!-- <span>取消</span> -->
          <el-popconfirm
            v-if="item.status*1==0"
            confirm-button-text="Confirm"
            cancel-button-text="Cancel"
            title="Are you sure to cancel?"
            @onConfirm='isCollect(item.id)'
          >
            <el-button class="del" type="danger" slot="reference">Cancel</el-button>
          </el-popconfirm>
        </div>
      </li>
    </ul>
    <div v-else class="peomp_con">
      <div class="prompt_img">
        <img :src="hrefurl+'/public/icon/without.png'" alt="" />
      </div>
      <p>No data is available!</p>
    </div>
    <el-pagination
      v-if="tableData.listnum>tableData.pagelistnum"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="tableData.thispage"
      :page-size="tableData.pagelistnum"
      layout="total, prev, pager, next "
      :pager-count="5"
      prev-text="prev"
      next-text="next"
      :total="tableData.listnum * 1"
    >
    </el-pagination>

    <!-- <template>
  <div class="pc_aboutgoods">
    <AboutList :tableData="tableData" name="取消预约" @isCollect='isCollect' @init='init'/>
  </div>
</template> -->
  </div>
</template>

<script>
// import AboutList from "../../../../components/pc/aboutList";
import { reqMyCorpApp, reqCorpAppOff } from "../../../../api";
export default {
  components:{
    // AboutList,
  },
  data(){
    return{
      tableData:{
        listnum: "15",
        pagelistnum: 20,
        prompt:"Are you sure to cancel?",
        list:[]
      }
    }
  },
  mounted(){
    this.init()
  },
  methods:{
    handleCurrentChange(a){//当前页改变时
      console.log(a);
      // 调用请求接口
      this.init(a)
    },

    handleSizeChange(a){//每页条数改变时  备用动态条数
      console.log(a);
    },
    async init(p=1){//已预约展商
      const response = await reqMyCorpApp(p)
      if (response.code*1==2) {//请求成功 有数据
        this.tableData={
          listnum:response.listnum,
          pagelistnum:response.pagelistnum,
          list:response.reslist
        }
      }else if (response.code*1==0) {//未登录
        this.$store.dispatch('outLogin')
        this.$router.push("/home")
        this.$store.dispatch('dialog',true)
        this.err(this,"Re-login please!")
      }else if(response.code*1==1){//没有预约
      }
    },
    async isCollect(id){//修改预约状态
      const response = await reqCorpAppOff(id)
      if (response.code==3) {
        let index = this.tableData.list.findIndex(item=>item.id==id)
        if (index>=0) {
          let {tableData} =this
          tableData.list.splice(index,1)
          this.tableData = tableData
        }
        this.success(this,'Cancel Successfully!')
      }else{
        this.err(this,'Timeout, please try...')
      }
    },

    exhjump(item){//跳转展商详情
      this.$router.push('/exhibitor/details/'+item.offid+'/'+item.ocid)
    }
  }
}

</script>

<style scoped>
  .pc_aboutgoods{
    width: 100%;
  }
  .ulList{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    padding:10px 4px;
  }
  .ulList>li{
    /* min-width: 330px;
    max-width: 430px; */
    /* width: 48%; */
    width: 100%;
    display: flex;
    /* justify-content: space-between; */
    background-color: #fafafa;
    padding-left: 10px;
    box-sizing: border-box;
    vertical-align: middle;
    margin-bottom: 20px;
    font-size: 12px;
    position: relative;
    border-radius: 5px;
    /* overflow: hidden; */
    min-height: 120px;

  }
  .ulList .left{
    width: 100px;
    vertical-align: middle;
    padding: 10px 0;
  }
  .ulList .center{
    position: relative;
    vertical-align: middle;
    /* min-width: 240px; */
    padding: 10px 10px 10px 20px;
    display: flex;
    width: calc(100% - 200px);
  }
  .userInformation{
    width: 50%;
  }
  .aboutContent{
    width: 50%;
  }
  .aboutContent>div{
    position: relative;
  }
  /* .aboutContent p span{
    color: #008baf;
  } */
  .ulList .center p{
    line-height: 24px;
    font-size: 14px;
  }
  .ulList .center .userInformation p{
    line-height: 30px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ulList .center .userInformation p:first-child{
    font-family: 'FjallaOne-Regular';
  }
  .ulList .center .aboutContent .title{
    position: relative;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    opacity: 0;
  }
  
  .ulList .center .h7{
    font-size: 18px;
    vertical-align: bottom;
    cursor: pointer;
  }
  .ulList .center .h7:hover{
    color: #008baf;
  }
  .center .h7 span{
    vertical-align: bottom;
    font-size: 14px;
    margin-left: 6px;
  }
  .ulList .center .time{
    position: absolute;
    left: 20px;
    bottom: 0px;
    font-size: 12px;
  }
  .ulList .center .aboutContent .con>p{
    max-height: 50px;
    height: auto;
    overflow: hidden;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  /* .ulList .center .hoverAccording{
    position: absolute;
    display: none;
    z-index: 9;
    background-color: #f5f5f5;
    border-radius: 4px;
    border: 1px solid #aaa;
    box-shadow: 0 3px 3px #d0cdcd;
    top: 30px;
    max-width: 300px;
    min-width: 300px;
    padding: 4px 6px;
    line-height: 20px;
  } */
  /* .sanjiao{
    position: absolute;
    top: -20px;
    left: 40px;
    display: inline-block;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #aaa;
    border-left: 10px solid transparent;
  } */
  .ulList .center .aboutContent>div:hover div,
  .ulList .center .aboutContent>div:hover div{
    display: block;
  }


  .ulList .right{
    position: absolute;
    right: 0;
    top: 0;
    width: 100px;
    /* background-color: #008baf; */
    color: white;
    font-weight: 600;
    vertical-align: middle;
    min-width: 40px;
    text-align: center;
    height: auto;
    font-size: 16px;
    /* padding-top: calc(50% - 7px); */
    height: 120px;
    box-sizing: border-box;
    line-height: 60px;
  }
  .ulList .reception{
    width: 100px;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
    color: #008baf;
    background:none;
    border: none;
  }
  .ulList .btn{
    color: #333;
  }
  .ulList .del{
    background-color: #008baf;
    border:none;
    transition: all .5s;
    border-radius: 5px;
    cursor: pointer;
    width: 100px;
    padding-right: 0;
    padding-left: 0;
    text-align: center;
  }
  .ulList .del:hover{
    background-color:#f08300; 
  }

  .prompt_img{
    width: 200px;
    margin: 100px auto 0;
    opacity: .8;
  }
  .peomp_con>p{
    font-size: 17px;
    text-align: center;
    line-height: 24px;
    padding-top: 10px;
    font-family: 'FjallaOne-Regular';
  }
  .goods_jump{
    color: #008baf;
    cursor: pointer;
  }

  .pc_aboutgoods>>>.el-pagination{
    padding: 40px 0 20px;
    text-align: center;
  }
  .pc_aboutgoods>>>.el-pager li,
  .pc_aboutgoods>>>.el-pagination .btn-next, 
  .pc_aboutgoods>>>.el-pagination .btn-prev{
    background-color: transparent;
  }


  @media (min-width: 768px) and (max-width: 900px) {
    .ulList .center{
      display: block;
    }
    .aboutContent, .userInformation{
      width: 100%;
    }
    .ulList .center .aboutContent .title{
      display: none;
    }
  }

</style>